import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setPassangerBaggageIndex } from "./reviewbookingSlice";
import { formatIndianNumber } from "../../_helpers/formatUtils";

const BaggageSelection = ({
  flightReviewDetails = [],
  travellers,
  selectedBaggagePerSegment,
  toggleBaggageSelection,
}: {
  flightReviewDetails: any;
  travellers: any[];
  selectedBaggagePerSegment: {
    [segmentIndex: number]: { [passengerIndex: number]: any };
  };
  toggleBaggageSelection: (
    ssr: any,
    passengerIndex: number,
    segmentIndex: number
  ) => void;
}) => {
  const dispatch = useAppDispatch();
  const passangerBaggageIndex = useAppSelector(
    (state) => state.reviewbooking.passangerBaggageIndex
  );

  const ssrData = useAppSelector((state) => state.reviewbooking.ssrData);

  return (
    <>
      <div className="seat-slection-title ssr-slection-title">
        <h4 className="m-0 passanger-tabs">
          {travellers.map((traveller, i) => {
            const baggageCount = Object.keys(
              selectedBaggagePerSegment?.[i] || {}
            ).length;

            const totalBaggageAmount = Object.values(
              selectedBaggagePerSegment?.[i] || {}
            ).reduce(
              (acc: number, ssr: any) => acc + (ssr?.Total_Amount || 0),
              0
            );

            return (
              <span
                className={`title-passanger-name ${
                  i === passangerBaggageIndex ? "active" : ""
                }`}
                onClick={() => dispatch(setPassangerBaggageIndex(i))}
              >
                {`${traveller?.initial} ${traveller?.first_name}  ${
                  traveller?.last_name
                }(${baggageCount} Baggage - ₹ ${formatIndianNumber(
                  totalBaggageAmount
                )})`}
              </span>
            );
          })}
        </h4>
      </div>
      {travellers.map((traveller, passengerIndex) => {
        if (passengerIndex !== passangerBaggageIndex) return null;

        return (
          <Swiper
            key={passengerIndex}
            slidesPerView="auto"
            spaceBetween={30}
            pagination={{ clickable: true }}
            navigation
            modules={[Navigation]}
            allowTouchMove={false}
            className="ssr-slider"
          >
            {ssrData?.map((ssrDetails: any, routeIndex: number) => {
              const totalSegment = ssrData?.length;

              const selectedBaggage =
                selectedBaggagePerSegment?.[passengerIndex]?.[routeIndex];
              const baggageAmount = selectedBaggage?.Total_Amount || 0;

              const baggageArray = ssrDetails?.SSRDetails?.filter(
                (e: any) => e?.SSR_Type === 0
              );

              return (
                <SwiperSlide
                  key={routeIndex}
                  className={totalSegment === 1 ? "one-slide" : "multi-slide"}
                >
                  <div
                    className="w-100"
                    style={{
                      backgroundColor: "white",
                      boxShadow: "0 0 5px #00000026",
                      borderRadius: "5px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      className="p-2 w-100"
                      style={{ borderBottom: "1px solid lightgray" }}
                    >
                      <div className="route-seat-selection-title">
                        <h4 className="m-0">
                          {
                            flightReviewDetails[routeIndex]?.Flight?.Segments[0]
                              ?.Origin_City
                          }{" "}
                          →{" "}
                          {
                            flightReviewDetails[routeIndex]?.Flight?.Segments[
                              flightReviewDetails[routeIndex]?.Flight?.Segments
                                ?.length - 1
                            ]?.Destination_City
                          }
                        </h4>
                        <span
                          className={`m-0 ${
                            !selectedBaggage
                              ? "pending-selection"
                              : "seat-amount"
                          }`}
                        >
                          {!selectedBaggage
                            ? "Selection pending"
                            : "₹ " + formatIndianNumber(baggageAmount)}
                        </span>
                      </div>
                      <div className="route-seat-selection-title">
                        <span className="m-0">
                          {selectedBaggage ? "1" : "No"} Baggage Selected
                        </span>
                        {selectedBaggage && (
                          <span className="m-0">Added to fare</span>
                        )}
                      </div>
                    </div>

                    <div className="position-relative">
                      <div className="grid grid-cols-12 main-ssrselection-layout">
                        <div className="space-y-2 col-span-12">
                          {baggageArray?.length > 0 ? (
                            baggageArray?.map((ssr: any) => {
                              const isSelected =
                                selectedBaggage?.SSR_Key === ssr.SSR_Key;

                              return (
                                <div
                                  className="flight-card mb-4"
                                  key={ssr.SSR_Key}
                                >
                                  <div className="flight-info">
                                    <h3 className="flight-title">
                                      {/* {ssr.SSR_TypeName} */}
                                      {ssr.SSR_TypeDesc}
                                    </h3>
                                    {/* <p className="flight-description">
                                      {ssr.SSR_TypeDesc}
                                    </p> */}
                                    <span className="ssr-price">
                                      ₹ {formatIndianNumber(ssr.Total_Amount)}
                                    </span>
                                  </div>

                                  <button
                                    type="button"
                                    className={`flight-select-btn ${
                                      isSelected ? "selected" : ""
                                    }`}
                                    onClick={() =>
                                      toggleBaggageSelection(
                                        ssr,
                                        passengerIndex,
                                        routeIndex
                                      )
                                    }
                                  >
                                    {isSelected ? "Selected" : "Select"}
                                  </button>
                                </div>
                              );
                            })
                          ) : (
                            <h4 className="text-center">
                              Baggage selection is unavailable for this segment
                            </h4>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        );
      })}
    </>
  );
};

export default BaggageSelection;
